import { useEffect, useState } from "react";
import "./patientFullView.css";
import { useTranslation } from "react-i18next";
import Widgets from "../../widgets";
import Icons from "../../Assets/Icons";
import moment from "moment";

const PatientInsuranceView = ({ insurance }) => {
  const { t } = useTranslation();
  const [processedInsurances, setProcessedInsurances] = useState([]);

  useEffect(() => {
    if (!insurance?.insurances) return;
    setProcessedInsurances(insurance.insurances);
  }, [insurance]);

  return (
    <div className="iv-container">
      <div className="iv-insurance-list iv-insurance-box">
        <div className="iv-title">{t("insuranceCmp")}</div>
        {processedInsurances?.map(
          (ins, idx) =>
            ins.isVerified && (
              <div key={idx}>
                <div className="iv-insurance">
                  <div className="pdl-hn">
                    <p className="pdl-hn-title">{t("insuranceCmpName")}</p>
                    <p className="pdl-number">{ins?.insurance?.company}</p>
                  </div>
                  <div className="iv-insurance-item">
                    <div className="piv-images">
                      {ins?.insurance?.image && (
                        <div className="piv-img-box">
                          <p>{t("insuranceImg")}</p>
                          <Widgets.SelectCard image={ins.insurance.image} idType={"insuranceImg"} front disabled />
                        </div>
                      )}
                    </div>
                  </div>
                  {(ins?.updatedAt || ins?.createdAt) && (
                    <div className="iv-updated-time">
                      <span>
                        <span style={{ display: "inline-block", marginTop: 8, color: "#6B7280", fontSize: 12 }}>
                          {t("updatedOn", "Updated on")}:
                          {" "}
                          {moment(ins?.updatedAt || ins?.createdAt).format("DD/MM/YYYY HH:mm")}
                        </span>
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )
        )}
        {(processedInsurances?.length === 0 || !processedInsurances?.some((ins) => ins.isVerified)) && (
          <div className="no-record-container">
            <div className="no-record-icon ins">
              <img src={Icons.CircleCross} />
            </div>
            <div className="no-record-text">{t("noInsuAvailable")}</div>
          </div>
        )}

        <div className="indicator">
          <div className="pdl-hn">
            <p className="pdl-hn-title">{t("insuranceIndicator")}</p>
            <p className="pdl-number">{t(insurance?.patientDetails?.insuranceCategory)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientInsuranceView;